import React from 'react';
import { useQuery } from '@apollo/client';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GraphQLError } from 'graphql';
import QUERY_PRODUCT from '../../graphql/query/product/product.query';
import { GetSingleProductQuery } from '../../graphql/generated/graphql';
import { ProductSingleView } from '../../components/organisms/ProductSingleView';
import usePublicShop from 'hooks/usePublicShop';
import { getProductTypesFromQuery } from '../../helpers/transformApiResponse/product';

const ProductSingle = ({ match }) => {
  const { data, loading, error } = useQuery<GetSingleProductQuery>(
    QUERY_PRODUCT,
    {
      variables: { id: match?.params?.idProduit }
    }
  );
  const { isPublicShop } = usePublicShop();
  if (loading) return <LoadingLayout />;
  if (error)
    return (
      <ErrorContainer
        detailErr={new GraphQLError('Erreur dans la récupération des produits')}
      />
    );
  const produit = getProductTypesFromQuery(data.produit.data);
  return <ProductSingleView produit={produit} isPublicShop={isPublicShop} />;
};

export default ProductSingle;
